<template>
  <div class="locale-switch">
    <div class="selected-flag" @click="toggleDropdown">
      <img :src="currentFlag" alt="flag" class="flag-img" />
      <span class="arrow">&#9660;</span>
    </div>
    <div v-if="isOpen" class="dropdown">
      <div class="dropdown-item" @click="switchLanguage('sw')">
        <img :src="tanzaniaFlag" alt="Swahili" class="flag-img" />
        <span>Swahili</span>
      </div>
      <div class="dropdown-item" @click="switchLanguage('en')">
        <img :src="ukFlag" alt="English" class="flag-img" />
        <span>English</span>
      </div>
    </div>
  </div>
</template>

<script>
import tanzaniaFlagImg from '@/assets/images/tanzania_flag.png'
import ukFlagImg from '@/assets/images/united_kingdom_flag.png'

export default {
  data() {
    return {
      isOpen: false,
      tanzaniaFlag: tanzaniaFlagImg,
      ukFlag: ukFlagImg,
    }
  },
  computed: {
    currentFlag() {
      return this.$i18n.locale === 'sw' ? this.tanzaniaFlag : this.ukFlag
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    switchLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.isOpen = false
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style scoped>
.locale-switch {
  position: relative;
  display: inline-block;
}

.selected-flag {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.flag-img {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
}

.arrow {
  font-size: 10px;
  color: #aaa;
}

.dropdown {
  position: absolute;
  top: 110%;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 100;
  min-width: 120px;
  white-space: nowrap;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #f3f4f6;
}
</style>
